import type { HeaderFeatures } from './type';

export const header: HeaderFeatures = {
    customerEntities: {
        enabled: false,
        _description:
            'Entity/profile switching for customers with multiple profiles. Available through the profile avatar dropdown in the main navigation',
    },
    plugins: {
        enabled: true,
        _description: 'Display/hide "Your Extras" option in the main navigation.',
        searchAndBuyPromo: {
            enabled: true,
            _description: 'Display/hide search and buy promo item from "Your Extras" menu',
        },
    },
};
